import { render, staticRenderFns } from "./Forget-Password.vue?vue&type=template&id=62f9fb71&scoped=true&"
import script from "./Forget-Password.vue?vue&type=script&lang=js&"
export * from "./Forget-Password.vue?vue&type=script&lang=js&"
import style0 from "./Forget-Password.vue?vue&type=style&index=0&id=62f9fb71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f9fb71",
  null
  
)

export default component.exports